import type { GetTrialsBySiteRequest } from '~/store/api/types/portal';

/** TanStack Query keys for trial registry lists and options. */
export const trialsKeys = {
  all: () => ['trials'] as const,
  list: () => ['trials', 'list'] as const,
  options: () => ['trials', 'options'] as const,
  bySite: (params: GetTrialsBySiteRequest) => ['trials', 'bySite', params] as const,
  detail: (trialId: string) => ['trials', 'detail', trialId] as const,
  savedFilters: (trialId: string) => ['trials', 'savedFilters', trialId] as const,
};
